/**
 * Runs async tasks strictly one after another. Transcript turns go through
 * this so they reach the server in the order they were spoken, and so ending
 * an interview can wait until the last turn has been saved.
 */
export function createSerialQueue(onError: (e: unknown) => void = () => {}) {
  let tail: Promise<void> = Promise.resolve();
  let pending = 0;
  return {
    push(task: () => Promise<unknown>) {
      pending++;
      tail = tail.then(task).then(
        () => void pending--,
        (e) => {
          pending--;
          onError(e);
        },
      );
    },
    /** Resolves once every task added so far, and any they add, has finished. */
    async drain() {
      while (pending > 0) await tail;
    },
  };
}
